(function($) {
	$(function() {
		console.log('running map js...');

		if (WPGMZA) {
			if (WPGMZA.is_admin === '1') {
				// don't run this in admin screens
				console.log('admin screen, bail...');
				return;
			}
			// map isn't loaded when this runs
			// let markerSource = 'cards-on-page';
			let markerSource = 'page-marker-data';
			// let markerSource = 'wp-rest-api';
			// let markerSource = 'map-on-page';
			let markerCollection = []; 			
			let mapInitIsReload = false;
			let mapInteractionState = {
				prevMarker: false,
				currentMarker: false,
				currentZoom: 0
			}
			
			$(document.body).on('init.wpgmza', function(e) {
				if (mapInitIsReload == false) {
					console.log('map created...');
					console.log('map init is reload? ', mapInitIsReload);
					let mapsOnPage = WPGMZA.maps;
					let soldPropertyMapId = mapsOnPage[0].id; // could be multiple maps, we're using the first one 
					window.soldPropertyMap = WPGMZA.getMapByID(soldPropertyMapId);
					window.mapElement = document.getElementById(`wpgmza_map_${soldPropertyMapId}`);
					console.log(window.soldPropertyMap);
					let defaultMapState = {
						zoom: soldPropertyMap.getZoom()
					};
					if (soldPropertyMap) {
						console.log('map is loaded');
					} else {
						console.log('map not loaded yet');
					}
			
					const $soldPropertyList = $('#sold-property-item-list');

					if (markerSource == 'cards-on-page') {
						/**
						 * Get marker data from list items on the page
						 */
						// stick with JS array for markerCollection to keep it consistent regardless of implementation
						markerCollection = $soldPropertyList.find('li').toArray().map(function(item, index) { 
							let $item = $(item);
							let details = $item.data('details');
							const marker = WPGMZA.Marker.createInstance({
								// map: soldPropertyMap, // this triggers map init
								position: {
									lat: parseFloat(details.lat),
									lng: parseFloat(details.lng),
								},
								title: details.title,
								address: details.address,
								icon: details.icon
							});
							// attach the marker to the item
							$item.data('marker', marker);
							return marker;
						});	
					} else if (markerSource == 'wp-rest-api') {
						/**
						 * TODO: get markers from REST API or WPGMZA object
						 * need to account for url pagination or AJAX pagination
						 */
					} else if (markerSource == 'map-on-page') {
						$(window).on('markersplaced.wpgmza', function() {
							console.log('loading from rest api...');
							markerCollection = soldPropertyMap.markers;
							let $markerList = $('<ul class="marker-list">');
							window.theMarkers = markerCollection;
							let markerListItemCollection = markerCollection.map(function(marker) {
								let listItem = 
								`<li class="sold-property">
									<h3 class="sold-property__title">${marker.title}</h3>
									<p class="sold-property__description">
										${marker.description}
									</p>
									<a class="sold-property__cta" href="#">View <span class="sr-only">${marker.title}</span>on Map</span></a>
								</li>`;
								return listItem;
							});
							$markerList.html(markerListItemCollection.join());
							// $markerList.append(markerListItemCollection);
							$('#custom-marker-listing').append($markerList);
						});

						return;
						
					} else if (markerSource == 'page-marker-data') {

						if (pageMarkerData && pageMarkerData.length !== 0) {
							markerCollection = pageMarkerData.map(function(details) {
								
								// let customMarkerDescription = 
								// 	`<a class="info-window-cta" aria-label="view more sale details for ${details.title}" href="${details.marker_post_url}">More Info</a>`
								let infowindowImageComponent = ``;
								if (details.image) {
									infowindowImageComponent = `<div class="infowindow-image-wrapper">${details.image}</div>`;
									console.log('IMAGE COMPONENT: ', infowindowImageComponent);
								}
								let customMarkerDescription = 
									`<div class="custom-infowindow-content-package">
										${infowindowImageComponent}
										<h3>${details.title}</h3>
									</div>
									`;

								const postMarker = WPGMZA.Marker.createInstance({
									id: details.marker_id,
									position: {
										lat: parseFloat(details.lat),
										lng: parseFloat(details.lng),
									},
									title: details.title,
									address: details.address,
									markerPostUrl: details.marker_post_url,
									// description: `<a class="info-window-cta" aria-label="view more sale details for ${details.title}" href="${details.marker_post_url}">More Info</a>`,
									description: customMarkerDescription,
									primaryImage: details.image, 
									icon: details.icon
								});
								return postMarker;
							});	
						}
					}
					
					$(window).on('select.wpgmza', function(e) {
						console.log('SELECT...');
						console.log('select event: ', e);
						let locationTitle = `<h3 class="infowindow-title">${e.target.title}</h3>`;
						let locationAddress = '';
						let addressParts = e.target.address.split(', ');
						let addressHtml = '';
						if (e.target.title == addressParts[0]) {
							// don't need the street address bcz it's the same as the title
							addressParts.shift(); // remove the first line
							if (addressParts.length == 3) {
								addressHtml = `<span class="infowindow-address-city">${addressParts[0]}</span> <span class="infowindow-address-state">${addressParts[1]}</span>, <span class="infowindow-address-zip">${addressParts[2]}</span>`
							} else {
								// no idea what the address format is so just combine as spans
								addressHtml = '<span class="address-part">' + addressParts.join(' </span><span class="address-part">') + '</span>';
							}
						} else {
							if (addressParts.length == 4) {
								addressHtml = `<span class="infowindow-address-street">${addressParts[0]}</span> <span class="infowindow-address-city">${addressParts[1]}</span>, <span class="infowindow-address-state">${addressParts[2]}</span> <span class="infowindow-address-zip">${addressParts[3]}</span>`
							} else {
								addressHtml = '<span class="address-part">' + addressParts.join(' </span><span class="address-part">') + '</span>';
							}
						}
						locationAddress = `<p class="infowindow-address">${addressHtml}</p>`;
						let locationImage = '';
						if (e.target.primaryImage) {
							locationImage = `<div class="infowindow-image-wrapper">${e.target.primaryImage}</div>`;
						}
						let infoWindowContent = 
						`<div class="infowindow-package">
						${locationImage}
						${locationTitle}
						${locationAddress}
						</div>`;
						e.target.infoWindow.setContent(infoWindowContent);
					});

						markerCollection.forEach(function(marker) {
							soldPropertyMap.addMarker(marker);
						});
						$soldPropertyList.on('click', 'li', function(e) {
							if ($(e.target).hasClass('sold-property-card__link') == false) {
								e.preventDefault();
								console.log('clicked card');
								let $item = $(this);
								let associatedMarkerId = $item.attr('id').replace('sp', 'marker');
								let associatedMarker = soldPropertyMap.getMarkerByID(associatedMarkerId);
								// if (mapInteractionState.prevMarker) {
								// 	mapInteractionState.prevMarker.setAnimation(0);
								// }
								mapInteractionState.currentMarker = associatedMarker;
								console.log('assoc marker: ', associatedMarker);
								mapElement.scrollIntoView();
								associatedMarker.panIntoView();
								soldPropertyMap.setZoom(12);
								console.log('marker before infowindow: ', associatedMarker);
								associatedMarker.trigger('select');
								// associatedMarker.openInfoWindow();
								// let infoWindowContent = associatedMarker.infoWindow.getContent();
								// infoWindowContent += `<a class="info-window-cta" aria-label="view more sale details for ${$item.data('title')}" href="${$item.find('a').attr('href')}">More Info</a>`
								// associatedMarker.infoWindow.setContent(infoWindowContent);
								// associatedMarker.setAnimation(1);
								// mapInteractionState.prevMarker = associatedMarker;
							}
						});
				} // end check if map init is a reload
				mapInitIsReload = true;
				// soldPropertyMap.addMarker(marker);
		}); // end map init event callback
	} else { // end check for WP Go Maps plugin object
		console.log('NO MAPS');
	}
		
	}); // document load callback
})(jQuery);